module.exports = {
      id: "icon-user-usage",
      viewBox: "0 0 50 50",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-user",
      toString: function () {
        return this.url;
      }
    }